module.exports = __webpack_public_path__ + "static/media/news2.e9fc3e76.png";